import { render } from "./ShippedOrders.vue?vue&type=template&id=218efa9c&scoped=true"
import script from "../js/shipped-orders.js?vue&type=script&lang=js&external"
export * from "../js/shipped-orders.js?vue&type=script&lang=js&external"

import "./ShippedOrders.vue?vue&type=style&index=0&id=218efa9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218efa9c"]])

export default __exports__